<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-img src="img/logo.png" fluid alt="Earned Value"/>
              <br><br>
              <b-form>
                <h1>Sign Up</h1>
                <p class="text-muted">Sign up for a FREE account. No credit card required.</p>
                <b-alert v-bind:show=this.showAlert variant="danger">Sign up failed. {{this.signUpErrorMessage}}</b-alert>
                <b-alert v-bind:show=this.invalidEmail variant="danger">This email has already signed up. Please <a href="#/signin">sign in</a>.</b-alert>
                <b-alert v-bind:show=this.invalidPassword variant="danger">Password must have at least 6 characters.</b-alert>
                <b-alert v-bind:show=this.invalidRepeatPassword variant="danger">Password and repeat password must be identical.</b-alert>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>@</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Email" autocomplete="email" v-bind:disabled=this.disableInputs v-model="email" />
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="password" class="form-control" placeholder="Password" autocomplete="password" v-bind:disabled=this.disableInputs v-model="password" />
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="password" class="form-control" placeholder="Repeat Password" autocomplete="repeat-password" v-bind:disabled=this.disableInputs v-model="repeatPassword" />
                </b-input-group>

                <p class="text-muted">Already have an account? <a href="#/signin">Sign In</a></p>
                <p class="text-muted">By signing up, you agree to our <a href="https://earnedvalue.app/terms" target="_blank">Terms of Service</a> and <a href="https://earnedvalue.app/privacy" target="_blank">Privacy Policy</a>.</p>

                <b-button variant="success" block v-bind:disabled=this.disableInputs v-on:click="submitClicked">{{this.disableInputs ? 'Please wait...' : 'Sign up for FREE account'}}</b-button>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js'
import {poolData} from '@/shared/aws-settings'
import axios from 'axios'

export default {
  name: 'Sign Up',

	data: () => {
		return {
      email: "",
      password: "",
      repeatPassword: "",
      showAlert: false,
      invalidEmail: false,
      invalidPassword: false,
      invalidRepeatPassword: false,
      signUpErrorMessage: "",
      disableInputs: false
    }
  },

  created () {
      var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

      var cognitoUser = userPool.getCurrentUser();

      if (cognitoUser != null) {
          cognitoUser.signOut();
      }


  },

  methods: {
    submitClicked: function (event) {
      event.target.blur();

      this.disableInputs = true;
      this.showAlert = false;
      this.invalidEmail = false;
      this.invalidPassword = false;
      this.invalidRepeatPassword = false;
      this.signUpErrorMessage = "";
      
      if (this.password.length < 6)
        this.invalidPassword = true;
      if (this.password != this.repeatPassword)
        this.invalidRepeatPassword = true;

      if (!this.invalidPassword && !this.invalidRepeatPassword) {

        var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
        var vueInstance = this;

        userPool.signUp(this.email, this.password, [], null, function(err, result){
            if (err) {
                if (err.code == "UsernameExistsException")
                  vueInstance.invalidEmail = true;
                else {
                  vueInstance.signUpErrorMessage = err.message;
                  vueInstance.showAlert = true;
                }
                vueInstance.disableInputs = false;
                return;
            }

            axios.put('/user-admin/signup', {email: vueInstance.email})
                .then(function (response) {
                  
                    var userData = {
                        Username : vueInstance.email,
                        Pool : userPool
                    };
                    var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

                    var authenticationData = {
                        Username : vueInstance.email,
                        Password : vueInstance.password,
                    };
                    var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);

                    cognitoUser.authenticateUser(authenticationDetails, {
                        onSuccess: function (result) {
                            var accessToken = result.getAccessToken().getJwtToken();
                            
                            // Use the idToken for Logins Map when Federating User Pools with identity pools or when passing through an Authorization Header to an API Gateway Authorizer
                            var idToken = result.idToken.jwtToken;

                            vueInstance.disableInputs = false;

                            vueInstance.$router.push({name: "Projects with ID", params: { id: 'welcome' }});
                        },

                        onFailure: function(err) {
                            vueInstance.showAlert = true;
                            vueInstance.disableInputs = false;
                        },

                        newPasswordRequired: function(userAttributes, requiredAttributes) {
                            vueInstance.showAlert = true;
                            vueInstance.disableInputs = false;
                        }

                    });

                })

                .catch(function (error) {
                    vueInstance.showAlert = true;
                    vueInstance.disableInputs = false;
                });

        });
      }
      else
        this.disableInputs = false;
    }
  }
}
</script>
